import type { IconDefinition } from '../index.tsx';

export const iconExternalLink: IconDefinition = {
  prefix: 'fas',
  iconName: 'iconExternalLink',
  icon: [
    16,
    16,
    [],
    '',
    'M10 0L9 1L11.2929 3.29289L6.2929 8.29289L7.70712 9.70711L12.7071 4.70711L15 7L16 6V0H10Z M1 2H6V4H3V13H12V10H14V15H1V2Z',
  ],
};
